export default "__VITE_ASSET__c7b2c41a__"